import { render, staticRenderFns } from "./GraficaModulos.vue?vue&type=template&id=1ef5c63c"
import script from "./GraficaModulos.vue?vue&type=script&lang=js"
export * from "./GraficaModulos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports